const pollReservationTimeout = 60 * 1000;

export default pollReservationTimeout;
